var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"odontograma",attrs:{"id":"div_odontograma"}},_vm._l((_vm.quadrantesArray(_vm.tipoDenticao)),function(quadrante){return _c('div',_vm._b({key:quadrante,staticClass:"quadrante"},'div',{
            id    : 'q' + quadrante,
            style : { 
                justifyContent   : ((quadrante % 2) == 0) ? 'start' : 'end',
                gridTemplateRows : (_vm.tipoDenticao == _vm.gConsts.denticao.PERMANTENTE) ? 'auto auto' : 'auto auto auto auto'
            }
        },false),_vm._l((_vm.denteNodes.filter(node => _vm.denteInQuadrante(parseInt(node.layout.label, 10), quadrante))),function(dente){return _c('div',_vm._b({key:dente.layout.label,staticClass:"denteLabel",attrs:{"data-selected":_vm.activeDenteNode == dente.id,"data-dente-ausente":!_vm.dentePresente(dente)},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick(dente)}}},'div',{
                id         : dente.id,
                style: {
                    '--dente-color' : _vm.getDenteColor(dente),
                },
                class : {
                    bottom : _vm.posicaoQuadrante(quadrante) == 'bottom'
                }
            },false),[_c('div',_vm._b({staticClass:"labelColor"},'div',{
                    id    : dente.id + '_color',
                    style : {
                        background : _vm.getDenteColor(dente),
                    },
                },false)),_c('div',_vm._b({staticClass:"labelText"},'div',{
                    id : dente.id + '_text',                 
                },false),[_vm._v(" "+_vm._s(dente.layout.label)+" ")])])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }